import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { useRouterHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import createBrowserHistory from 'history/lib/createBrowserHistory';
import Raven from 'raven-js';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import injectTapEventPlugin from 'react-tap-event-plugin';
import buildStore from './buildStore';
import createRouterShell from './RouterShell';
import firebaseConfig from './config/firebase';
import logon from './modules/auth/actions/logon';
import finishLogoff from './modules/auth/actions/finishLogoff';

if (process.env.NODE_ENV === 'development') {
  const Immutable = require('immutable');
  const installDevTools = require('immutable-devtools');
  installDevTools(Immutable);
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.href.indexOf('localhost') === -1) {
    Raven.config('https://e09b67ab677f4c2eb07ab36b98aef993@sentry.io/114051', {
      release: process.env.REACT_APP__VERSION,  // eslint-disable-line no-undef
      environment: process.env.REACT_APP__ENVIRONMENT,  // eslint-disable-line no-undef
    }).install();
  }

  firebase.initializeApp(firebaseConfig);

  // Needed for onTouchTap
  // http://stackoverflow.com/a/34015469/988941
  injectTapEventPlugin();

  const appHistory = useRouterHistory(createBrowserHistory)();
  const store = buildStore(window, appHistory);
  const history = syncHistoryWithStore(appHistory, store, {
    selectLocationState: state => state.get('routing')
  });
  const RouterShell = createRouterShell(store, history);

  ReactDOM.render(
      (<Provider store={store}>
        <MuiThemeProvider>
          <RouterShell />
        </MuiThemeProvider>
      </Provider>),
    document.getElementById('root'));

  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      // User is signed in.
      /* eslint-disable no-console */
      console.log('Signed in', user);

      store.dispatch(logon(user));
    }
    else {
      // No user is signed in.
      /* eslint-disable no-console */
      console.log('Not signed in');

      store.dispatch(finishLogoff());
    }
  });
});



// WEBPACK FOOTER //
// ./src/index.js